// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"466c7b14","433":"a4173b52","554":"6961ae33","920":"754542f4"}[chunkId] + ".chunk.js";
};